import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../Component/Footer/Footer";
import AIheader from "../RentAI/AIheader";
import "../Home/home.css";
import "./enterprise.css";

/* Shell for the /enterprise pages, ported from the v0 prototype's /rentid-enterprise.
   Everything inside `.rd-home.rd-ent` uses the scoped Tailwind build (tailwind.config.js) and
   home.css's reset; enterprise.css swaps in the light v0 palette. The shared site header and
   footer stay outside the wrapper. */
export default function EnterpriseLayout({ title, description, path, children }) {
  const url = `https://www.rentid.io${path}`;
  // Pages on this site reset scroll themselves (scrollRestoration is manual).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <link rel="canonical" href={url} />
      </Helmet>
      <AIheader />
      <div className="rd-home rd-ent">
        <main className="ent-main min-h-screen overflow-x-clip bg-background text-foreground">{children}</main>
      </div>
      <Footer />
    </>
  );
}
